import React from "react";
import "./newUser.css";
import { Collapse, ConfigProvider, Switch } from "antd";
import {
    permissionCellStyle,
    permissionLabelStyle,
    permissionSwitchTheme,
    permissionThemeVars,
} from "../../theme/globalStyle/globalStyle";

const { Panel } = Collapse;

/** Chaves de grupo exibidas neste componente — usado para “Selecionar todos” geral coerente com os switches. */
export const PERMISSION_MASTER_GROUP_KEYS = [
    "salesDashboard",
    "client",
    "user",
    "driver",
    "shipper",
    "freight",
    "freightPricing",
    "freightDriver",
    "freightFreight",
    "freightStoppingPointLatLong",
    "product",
    "mdfe",
    "import",
    "payment",
    "tableIcms",
    "ocurrence",
    "revenue",
    "tablePrice",
    "perfil",
    "accompaniment",
    "simulatorFreight",
    "budget",
];

/**
 * Retorna true somente se, em cada grupo da UI, `selecionarTodos` estiver true
 * (ou seja, todos os flags do grupo estão alinhados com “marcar tudo” daquele grupo).
 * Ignora o flag persistido no banco quando ele não reflete o estado real.
 */
export function calcularSelecionarTodosGeralCoerente(permissoes) {
    if (!permissoes || typeof permissoes !== "object") return false;
    return PERMISSION_MASTER_GROUP_KEYS.every((key) => {
        const g = permissoes[key];
        return Boolean(g && g.selecionarTodos === true);
    });
}

export default function Permission({
    view,
    permissoes,
    handleChange,
    handleSelecionarTodosGeral,
}) {

    const groupsCreate = [
        { key: "salesDashboard", label: "Dashboard Vendas" },
        { key: "simulatorFreight", label: "Simulador de Frete" },
        { key: "client", label: "Cliente" },
        { key: "user", label: "Usuário" },
        { key: "driver", label: "Motorista" },
        { key: "shipper", label: "Embarcador" },
        { key: "freight", label: "Frete" },
        { key: "product", label: "Produto" },
        { key: "budget", label: "Orçamento" },
    ];

    const groupsFreightSubPermissions = [
        { key: "freightPricing", label: "Precificação" },
        { key: "freightDriver", label: "Motorista" },
        { key: "freightFreight", label: "Frete" },
        { key: "freightCannotRelease", label: "Liberar frete" },
        // { key: "freightViewEditDriver", label: "Motorista no frete (visualizar/editar)" },
    ];

    const groupsFreightStoppingPoint = [
        { key: "freightStoppingPointLatLong", label: "Latitude e Longitude" },
    ];

    const groupsFiscal = [
        { key: "mdfe", label: "MDF-E" },
        { key: "import", label: "Importação" },
    ];

    const groupsPayment = [
        { key: "payment", label: "Pagamento" },
    ];

    const groupsParameters = [
        { key: "tableIcms", label: "Tabela ICMS" },
        { key: "ocurrence", label: "Ocorrências" },
        { key: "tablePrice", label: "Tabela de Preço" },
        { key: "perfil", label: "Perfil" },
        { key: "revenue", label: "Faturamento" },
    ];

    const groupsAcomp = [
        { key: "accompaniment", label: "Acompanhamento" },
    ]

    const renderSwitch = (groupKey, permissionField) => {
        const checked = !!permissoes?.[groupKey]?.[permissionField];

        return (
            <td style={permissionCellStyle}>
                <Switch
                    disabled={view}
                    checked={checked}
                    onChange={() => handleChange(groupKey, permissionField)}
                    className="permission-switch"
                />
            </td>
        );
    };

    const renderCell = (groupKey, fieldKey) => {
        if (fieldKey === "null") {
            return <td style={permissionCellStyle} />;
        }

        if (fieldKey === "single") {
            return renderSwitch(groupKey, "isView");
        }

        return renderSwitch(groupKey, fieldKey);
    };

    const selecionarTodosGeralCoerente =
        calcularSelecionarTodosGeralCoerente(permissoes);

    return (
        <ConfigProvider theme={permissionSwitchTheme}>
            <div className="permission-root" style={{ width: "100%", overflowX: "auto", ...permissionThemeVars }}>
                <div className="permission-select-all">
                    <label style={permissionLabelStyle}>
                        <Switch
                            disabled={view}
                            checked={selecionarTodosGeralCoerente}
                            onChange={handleSelecionarTodosGeral}
                            className="permission-switch"
                        />
                        <span>Selecionar Todos</span>
                    </label>
                </div>

            <Collapse accordion className="collapse-full" >
                <Panel header={"Cadastros"} key={"permissoes"}>
                    <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                                <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Selecionar Todos</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupsCreate.map((g) => {
                                if (g.key === "salesDashboard" || g.key === "simulatorFreight") {
                                    return (
                                        <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                            <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                            {renderCell(g.key, "null")}
                                            {renderCell(g.key, "single")}
                                            {/* {renderCell(g.key, "selecionarTodos")} */}
                                            {/* {renderCell(g.key, "isView")} */}
                                        </tr>
                                    );
                                }
                                return (
                                    <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                        <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                        {renderCell(g.key, "selecionarTodos")}
                                        {renderCell(g.key, "isView")}
                                        {renderCell(g.key, "isCreate")}
                                        {renderCell(g.key, "isEdit")}
                                        {renderCell(g.key, "isDelete")}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <Collapse className="collapse-full" style={{ marginTop: 12 }}>
                        <Panel header={"Frete Sub Permissões"} key={"cadastros-frete-sub-permissoes"}>
                            <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr style={{ background: "#f5f5f5" }}>
                                        <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                        {/* <th style={{ textAlign: "center", padding: "8px 12px" }}>Selecionar Todos</th> */}
                                        <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                        {/* <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th> */}
                                        <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th>
                                        {/* <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupsFreightSubPermissions.map((g) => {
                                        if (g.key === "freightCannotRelease") {
                                            return (
                                                <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                                    <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                                    {renderCell(g.key, "single")}
                                                </tr>
                                            );
                                        }
                                        return (

                                            <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                                <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                                {/* {renderCell(g.key, "selecionarTodos")} */}
                                                {renderCell(g.key, "isView")}
                                                {/* {renderCell(g.key, "isCreate")} */}
                                                {renderCell(g.key, "isEdit")}
                                                {/* {renderCell(g.key, "isDelete")} */}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>

                            <Collapse className="collapse-full" style={{ marginTop: 12 }}>
                                <Panel header={"Pontos de Parada"} key={"cadastros-frete-pontos-de-parada"}>
                                    <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr style={{ background: "#f5f5f5" }}>
                                                <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                                {/* <th style={{ textAlign: "center", padding: "8px 12px" }}>Selecionar Todos</th> */}
                                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                                {/* <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th> */}
                                                {/* <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th> */}
                                                {/* <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {groupsFreightStoppingPoint.map((g) => (
                                                <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                                    <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                                    {/* {renderCell(g.key, "selecionarTodos")} */}
                                                    {renderCell(g.key, "isView")}
                                                    {/* {renderCell(g.key, "isCreate")} */}
                                                    {/* {renderCell(g.key, "isEdit")} */}
                                                    {/* {renderCell(g.key, "isDelete")} */}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </Panel>
                            </Collapse>
                        </Panel>
                    </Collapse>
                </Panel>
            </Collapse>

            <Collapse accordion className="collapse-full" >
                <Panel header={"Fiscal"} key={"permissoes-repetido"}>
                    <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                                <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Selecionar Todos</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupsFiscal.map((g) => (
                                <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                    {renderCell(g.key, "selecionarTodos")}
                                    {renderCell(g.key, "isView")}
                                    {renderCell(g.key, "isCreate")}
                                    {renderCell(g.key, "isEdit")}
                                    {renderCell(g.key, "isDelete")}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Panel>
            </Collapse>

            <Collapse accordion className="collapse-full" >
                <Panel header={"Financeiro"} key={"permissoes-financeiro"}>
                    <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                                <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Selecionar Todos</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupsPayment.map((g) => (
                                <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                    {renderCell(g.key, "selecionarTodos")}
                                    {renderCell(g.key, "isView")}
                                    {renderCell(g.key, "isCreate")}
                                    {renderCell(g.key, "isEdit")}
                                    {renderCell(g.key, "isDelete")}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Panel>
            </Collapse>

            <Collapse accordion className="collapse-full" >
                <Panel header={"Parâmetros"} key={"permissoes-parametro"}>
                    <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                                <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Selecionar Todos</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupsParameters.map((g) => {
                                if (g.key === "revenue") {
                                    return (
                                        <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                            <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                            {renderCell(g.key, "null")}
                                            {renderCell(g.key, "single")}
                                        </tr>
                                    );
                                }
                                return (
                                    <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                        <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                        {renderCell(g.key, "selecionarTodos")}
                                        {renderCell(g.key, "isView")}
                                        {renderCell(g.key, "isCreate")}
                                        {renderCell(g.key, "isEdit")}
                                        {renderCell(g.key, "isDelete")}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </Panel>
            </Collapse>

            <Collapse accordion className="collapse-full" >
                <Panel header={"Acompanhamento"} key={"permissoes-acompanhamento"}>
                    <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                                <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}></th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                {/* <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {groupsAcomp.map((g) => (
                                <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                    {renderCell(g.key, "null")}
                                    {renderCell(g.key, "single")}
                                    {/* {renderCell(g.key, "isCreate")}
                                    {renderCell(g.key, "isEdit")}
                                    {renderCell(g.key, "isDelete")} */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Panel>
            </Collapse>
        </div>
        </ConfigProvider>
    );

}
